import { EditUnsafeScaffoldReportSummaryCommand } from './edit-unsafe-scaffold-report-summary-command';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class MarkUnsafeScaffoldReportCompleteCommand {
  EditUnsafeScaffoldReportSummaryCommand: EditUnsafeScaffoldReportSummaryCommand;
  ScaffoldId: string;
  ScaffoldDiaryId: string;
  InspectorComments: { [key: string]: string };
  InspectionDefectComments: { [key: string]: string };
  InspectionFollowupInspectorsRecommendation: { [key: string]: string };
  UnsafeReportSiteManagerRecommendation: string;
  OffsetFromUtc: number;
  SubmittedOn: string;
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


